import { MapPinnedIcon, StoreIcon, TagIcon, WarehouseIcon } from 'lucide-react';
import { Link } from 'react-router';

import type { LocationDTO } from '@invenco/accounts-interface';
import { LocationType } from '@invenco/accounts-interface';

import { AddressDisplay } from '@/components/address-display';
import { Badge } from '@/components/core/badge';
import { Button } from '@/components/core/button';
import { DetailList } from '@/components/detail-list';
import { locationTypeTitle } from '@/shared/title-maps';

type Props = {
  location?: LocationDTO;
  isLoading?: boolean;
};

export function LocationDetailsSection({ location, isLoading }: Props) {
  return (
    <DetailList
      title="Details"
      isLoading={isLoading}
      items={[
        {
          icon: TagIcon,
          label: 'Type',
          value: location?.type ? (
            <Badge variant="secondary">{locationTypeTitle[location.type]}</Badge>
          ) : undefined,
        },
        {
          icon: StoreIcon,
          label: 'Account',
          value: location?.accountId ? (
            <Button variant="link" className="h-auto p-0" asChild>
              <Link to={`/accounts/${location.accountId}`}>{location.accountName}</Link>
            </Button>
          ) : undefined,
        },
        ...(location?.type === LocationType.MANAGED
          ? [
              {
                icon: WarehouseIcon,
                label: 'Warehouse location',
                value: location.warehouseLocationId ? (
                  <Button variant="link" className="h-auto p-0" asChild>
                    <Link to={`/locations/${location.warehouseLocationId}`}>
                      {location.warehouseLocationName}
                    </Link>
                  </Button>
                ) : undefined,
              },
            ]
          : []),
        {
          icon: MapPinnedIcon,
          label: 'Address',
          value: <AddressDisplay address={location?.address} isLoading={isLoading} />,
        },
      ]}
    />
  );
}
